import React from 'react';
import { Card, Badge, Flex, Typography } from '@app/ui';
import { shortDate } from '@app/utils/formatters';
import { ExposureType } from '../../utils/broadcastsUtils';

interface ExposureTileProps {
    type: ExposureType;
    frameUrl: string;
    smv: string;
    rightsholderLogoUrl: string;
    placementName: string;
    sponsorName: string;
    contentDate: string;
    onClick: () => void;
}

const ExposureTile = ({
    type,
    frameUrl,
    smv,
    rightsholderLogoUrl,
    placementName,
    sponsorName,
    contentDate,
    onClick,
}: ExposureTileProps) => {
    const iconClass = {
        [ExposureType.VerbalMention]: 'fas fa-megaphone',
        [ExposureType.Visual]: 'fas fa-tv-retro',
    };

    return (
        <Card
            hoverable
            cover={
                <>
                    {frameUrl ? (
                        <img
                            src={frameUrl}
                            style={{
                                objectFit: 'cover',
                                height: 160,
                            }}
                        />
                    ) : (
                        <div
                            style={{
                                objectFit: 'cover',
                                height: 160,
                                backgroundColor: 'rgba(131, 131, 131, 1)',
                            }}
                        />
                    )}
                    {type === ExposureType.VerbalMention && (
                        <div
                            style={{
                                position: 'absolute',
                                left: 0,
                                top: 0,
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <i
                                className="fas fa-play-circle"
                                style={{
                                    fontSize: 48,
                                    color: '#F1F2F3',
                                }}
                            />
                        </div>
                    )}
                </>
            }
            onClick={onClick}
            style={{
                minWidth: 300,
                margin: 4,
            }}
        >
            <Badge.Ribbon
                text={` SMV: ${smv}`}
                style={{
                    transform: 'translate3d(0px, -32px, 0)',
                }}
            >
                <Flex gap={12} align="center" style={{ margin: 4 }}>
                    <div
                        style={{
                            width: 32,
                            height: 32,
                            borderRadius: 16,
                            overflow: 'hidden',
                            border: `1px solid #009FDF`,

                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                        }}
                    >
                        <img
                            src={rightsholderLogoUrl}
                            height="100%"
                            width="100%"
                        />
                    </div>
                    <Flex justify="space-between" flex={1}>
                        <Flex vertical gap={4}>
                            <Typography.Text
                                type="secondary"
                                style={{
                                    fontSize: 14,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    maxWidth: 160,
                                    color: '#5F6D7E',
                                }}
                            >
                                {placementName}
                            </Typography.Text>
                            <Typography.Text
                                style={{
                                    fontSize: 13,
                                    fontWeight: 400,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    maxWidth: 160,
                                    color: '#5F6D7E',
                                }}
                            >
                                {sponsorName}
                            </Typography.Text>
                        </Flex>
                        <Flex vertical gap={4} align="flex-end">
                            <Typography.Text
                                type="secondary"
                                style={{
                                    fontSize: 13,
                                    marginRight: 4,
                                    color: '#5F6D7E',
                                }}
                            >
                                {shortDate(contentDate)}
                            </Typography.Text>
                            <i
                                className={iconClass[type]}
                                style={{ fontSize: 16, color: '#5F6D7E' }}
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </Badge.Ribbon>
        </Card>
    );
};

export default ExposureTile;
